module.exports = __webpack_public_path__ + "img/receipt-example.fa078dca.png";